import { Component, Input, ViewChild } from '@angular/core';
import { fadeInUp400ms } from 'src/@vex/animations/fade-in-up.animation';
import { filter, Observable, ReplaySubject } from "rxjs";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import Swal from "sweetalert2";
import { TableColumn } from "src/@vex/interfaces/table-column.interface";
import { UntypedFormControl } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { SelectionModel } from "@angular/cdk/collections";
import { aioTableLabels } from "src/assets/static-data/aio-table-data";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { stagger40ms } from "src/@vex/animations/stagger.animation";
import { LoadingOrderService } from 'src/app/shared/services/loading-order.service';
import { ILoadingOrder } from 'src/core/interfaces/loading-order';
import { LoadingOrderStatus } from 'src/assets/static-data/enums/loading-order-satus.enum';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { CompeleteOrderComponent } from './compelete-order/compelete-order.component';
import { ICompleteDriverTripDto } from 'src/core/interfaces/IComplete-driver-trip';

@UntilDestroy()
@Component({
  selector: 'app-driver-trips',
  templateUrl: './driver-trips.component.html',
  styleUrl: './driver-trips.component.scss',
  providers: [DatePipe],
  animations: [
    fadeInUp400ms,
    stagger40ms
  ],
})
export class DriverTripsComponent {
  layoutCtrl = new UntypedFormControl("boxed");

  /**
   * Simulating a service with HTTP that returns Observables
   * You probably want to remove this and do all requests in a service with HTTP
   */

  LoadingOrders: ILoadingOrder[];
  subject$: ReplaySubject<ILoadingOrder[]> = new ReplaySubject<ILoadingOrder[]>(
    1
  );
  data$: Observable<ILoadingOrder[]> = this.subject$.asObservable(); 
  isLoading = false
  isInactiveLoading = false;
  clicked = false;
  lastSyncDate:Date;
  filteredDataStatus:number=-1;
  currentPage = 0;
  activeCount = 0;
  filteredDataSearch:string=null;
  isRtl: boolean;
  totalRows:number=0;

  constructor(
    private loadingOrderService: LoadingOrderService,
    private router: Router,
    private translateService: TranslateService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
  ) {}
  @Input()
  columns: TableColumn<ILoadingOrder>[] = [
    {
      label: "Checkbox",
      property: "checkbox",
      type: "checkbox",
      visible: true,
    },
    {
      label: this.translateService.instant("ORDER_NUMBER.TEXT"),
      property: "orderNumber",
      type: "text",
      visible: true,
    },
    {
      label: this.translateService.instant("CUSTOMER_REF_NO.TEXT"),
      property: "customerRefNo",
      type: "text",
      visible: true,
    },
    
    {
      label: this.translateService.instant("CUSTOMER_NAME.TEXT"),
      property: "customerName",
      type: "text",
      visible: true,
    },
    {
      label: this.translateService.instant("FACTORY_NAME.TEXT"),
      property: "factoryName",
      type: "text",
      visible: true,
    },
    {
      label: this.translateService.instant("STATUS.TEXT"),
      property: "status",
      type: "text",
      visible: true,
    },

    {
      label: this.translateService.instant("TRANSACTION_DATE.TEXT"),
      property: "transactionDate",
      type: "text",
      visible: true,
    },
    {
      label: this.translateService.instant("ACTIONS.TEXT"),
      property: "actions",
      type: "button",
      visible: true,
    },
  ];
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100, 250, 500, 1000, 5000, 10000];
  dataSource: MatTableDataSource<ILoadingOrder> | null;
  selection = new SelectionModel<ILoadingOrder>(true, []);
  searchCtrl = new UntypedFormControl();

  labels = aioTableLabels;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }


  ngOnInit() {
    
    this.isRtl = this.translateService.currentLang == 'ar'|| this.translateService.currentLang == 'ur'?true:false;
    // this.getLoadingOrders();
    this.getDriverTrips();
    this.dataSource = new MatTableDataSource();
    //this.isRtl = this.translateService.currentLang == 'ar'?true:false;

    this.data$.pipe(filter<ILoadingOrder[]>(Boolean)).subscribe((LoadingOrders) => {
      this.LoadingOrders = LoadingOrders;
      this.dataSource.data = LoadingOrders;
    });
    this.searchCtrl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((value) => this.onFilterChange(value));
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  
  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getDriverTrips();
  }
  
  getDriverTrips(criteria = null) {
    this.isLoading = true;
    this.loadingOrderService.getDriverTrips(this.currentPage, this.pageSize, true, criteria).subscribe((response) => {
      console.log("Loading Orders", response.data.items);
      this.totalRows=response.data.count;
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = response.data.count;
      });
      const documentStatusMap: { [key in LoadingOrderStatus]: string } = {
        [LoadingOrderStatus.Draft]: "Draft",
        [LoadingOrderStatus.InProgress]: "InProgress",
        [LoadingOrderStatus.Completed]: "Completed",
        [LoadingOrderStatus.Synced]: "Synced",
        [LoadingOrderStatus.Processing]: "Processing"
    };
    const getStatusString = (status: LoadingOrderStatus): string => {
        return documentStatusMap[status];
    };
    this.LoadingOrders = response.data.items.map(order => ({
      ...order,
      statusLabel: getStatusString(order.status),
      customerName:  order.customerName ? order.customerName : "N/A",
      factoryName: order.factoryName ? order.factoryName : "N/A",
      InProgress: order.status === LoadingOrderStatus.InProgress,
      // isApproved: order.status === LoadingOrderStatus.Approved,
      isSynced: order.status === LoadingOrderStatus.Synced,
      isProcessing: order.status === LoadingOrderStatus.Processing,
      isDraft: order.status === LoadingOrderStatus.Draft,
      isCompeleted: order.status === LoadingOrderStatus.Completed,
      transactionDate: this.datePipe.transform(order.transactionDate, 'dd/MM/yyyy')  //'dd/MM/yyyy'+ ' | '+ 'HH:mm'
    }));
    
    
    console.log(this.LoadingOrders);
      this.isLoading = false;
      this.subject$.next(this.LoadingOrders);
    });
  }


  getLoadingOrder(id: number) {
    this.loadingOrderService.getById(id).subscribe((response) => {
      console.log(response.data);
    });
  }

  deleteLoadingOrder(loadingOrder: ILoadingOrder) {
    Swal.fire({
      title: this.translateService.instant("ARE_YOU_SURE.TEXT"),
      text: this.translateService.instant("YOU_WONT_BE_ABLE_TO_REVERT_THIS.TEXT"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.translateService.instant("YES_DELETE_IT.TEXT"),
      cancelButtonText: this.translateService.instant("CANCEL.TEXT"),
    }).then((result) => {
      console.log(result.isConfirmed);
      if (result.isConfirmed) {
        this.loadingOrderService.delete(loadingOrder.id).subscribe((response) => {
          if (response.statusCode === 200) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: this.translateService.instant("LOADING_ORDER_DELETED_SUCCESSFULLY.TEXT"),
              timer: 1500,
            });
            // this.getLoadingOrders();
          }
          else {
            Swal.fire(
              this.translateService.instant("SOMETHING_WENT_WRONG.TEXT"),
              this.translateService.instant("PLEASE_CONTACT_ADMIN.TEXT"),
              "error"
            );
          }
        });
      }
    });
}
viewLoadingOrder(loadingOrder: ILoadingOrder) {
  this.router.navigate(["/transactions/loading-order/view", loadingOrder.id]);
}


  onFilterChange(value: string) {
    if (!this.dataSource) {
      return;
    }
    value = value.trim();
    value = value.toLowerCase();
    this.dataSource.filter = value;
  }

  toggleColumnVisibility(column, event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  

  CompeletedLoadingOrder(loadingorder: ILoadingOrder) {
    this.dialog
      .open(CompeleteOrderComponent,{data:loadingorder})
      .afterClosed()
      .subscribe((result) => {
        this.getDriverTrips();
        
      });
  }

//   CompeletedLoadingOrder(loadingorder: ILoadingOrder) {
// // // debugger;
//     this.dialog
//       .open(CompeleteOrderComponent, {
//         data: loadingorder,
//       })
//       .afterClosed()
//       .subscribe((updatedloadingorder) => {
//         if (updatedloadingorder) {
//           const CompleteDriverTripDto: ICompleteDriverTripDto = {
//             deliveryAuthAttachmentFileName: loadingorder.fileName,
//             deliveryAuthAttachmentFileContent: loadingorder.selectedFile
//           };
//           this.loadingOrderService.completeDriverTrip(loadingorder.id, CompleteDriverTripDto).subscribe(() => {
//             Swal.fire(
//               this.translateService.instant("loadingorder_DELIVERED_SUCCESSFULLY.TEXT"),
//               "",
//               "success"
//             );
//             this.getDriverTrips();
            
//           });
//         }
//       });
//   }

}
